import { Result, backendApi } from "./backendApi";

export interface GdvEntryModel {
  hsn?: string;
  tsn?: string;
  marke?: string;
  fahrzeugtype?: string;
  leistungPs?: number;
  leistungKw?: number;
  hubraum?: number;
  kraftstoff?: string;
}

interface DatEntryDetailsModel {
  make?: string;
  main?: string;
  subType?: string;
  engine?: string;
  bodyStyle?: string;
  fuelType?: string;
  constructionDate?: string;
}

export interface DatEntryModel {
  hsn?: string;
  tsn?: string;
  make?: string;
  mainType?: string;
  subType?: string;
  details?: DatEntryDetailsModel[];
}

export interface CrsEntryModel {
  hsn?: string;
  tsn?: string;
  description?: string;
}

export interface HsnTsnModel {
  hsn?: string;
  tsn?: string;
}

class GetHsnTsnViewRequest {
  recId?: number;
}

export class GetHsnTsnViewResponse {
  gdvEntries?: GdvEntryModel[];
  datEntries?: DatEntryModel[];
  crsEntries?: CrsEntryModel[];
  selectedEntries?: HsnTsnModel[];
}

export class UpdateHsnTsnRequest {
  recId?: number;
  selectedEntries?: HsnTsnModel[];
  crsEntries?: CrsEntryModel[];
}

export const hsntsnAPI = {
  async getHsnTsnView(recId: number): Promise<Result<GetHsnTsnViewResponse>> {
    let response =
      await backendApi.sendAndGetResponseAsync<GetHsnTsnViewResponse>(
        "GetHsnTsnView",
        { recId: recId } as GetHsnTsnViewRequest
      );

    if (response.ok) {
      return { ok: true, value: response.value ?? {} };
    }

    return response;
  },

  async updateHsnTsnEntries(
    recId: number,
    selectedEntries: HsnTsnModel[],
    crsEntries: CrsEntryModel[]
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("UpdateHsnTsn", {
      recId: recId,
      selectedEntries: selectedEntries,
      crsEntries: crsEntries,
    } as UpdateHsnTsnRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    return response;
  },
};
